const data = [
    {
        title: "Dashboard",
        routing: "dashboard"
    },
    {
        title: "Medicine",
        sub: [
            {
                title: "Consultant",
                routing: "consultant"
            },
            {
                title: "Client",
                routing: "client"
            },
            // {
            //     title: "Appointments",
            //     routing: "appointmnents"
            // },
            // {
            //     title: "Transactions",
            //     routing: "transactions"
            // },
            {
                title: "All Booking",
                routing: "all-booking"
            },
            {
                title: "Privacy Policy Page",
                routing: "add-privacy-policy"
            },
            {
                title: "Terms&Condition Page",
                routing: "add-terms-condition"
            },
            {
                title: "Web Setting Page",
                routing: "websetting"
            }
        ]
    },
    {
        title: "Nationality",
        sub: [
            {
                title: "Add Nationality",
                routing: "add-nationality"
            },
            {
                title: "View Nationality",
                routing: "view-nationality"
            },
            {
                title: "View Trash Nationality",
                routing: "view-trash-nationality"
            }
        ]
    },
    {
        title: "Country",
        sub: [
            {
                title: "Add Country",
                routing: "add-country"
            },
            {
                title: "View Country",
                routing: "view-country"
            },
            {
                title: "View Trash Country",
                routing: "view-trash-country"
            }
        ]
    },
    {
        title: "City",
        sub: [
            {
                title: "Add City",
                routing: "add-city"
            },
            {
                title: "View City",
                routing: "view-city"
            },
            {
                title: "View Trash City",
                routing: "view-trash-city"
            }
        ]
    },

    {
        title: "Disorder",
        sub: [
            {
                title: "Add Disorders",
                routing: "add-disorders"
            },
            {
                title: "View Disorders",
                routing: "view-disorders"
            },
            {
                title: "View Trash Disorders",
                routing: "view-trash-disorders"
            }
        ]
    },
    {
        title: "Specialization",
        sub: [
            {
                title: "Add Specialization",
                routing: "add-specialization"
            },
            {
                title: "View Specialization",
                routing: "view-specialization"
            },
            {
                title: "View Trash Specialization",
                routing: "view-trash-specialization"
            }
        ]
    },
    {
        title: "Blog",
        sub: [
            {
                title: "Add Blog",
                routing: "add-blog"
            },
            {
                title: "View Blog",
                routing: "view-blog"
            },
            {
                title: "View Trash Blog",
                routing: "view-trash-blog"
            }
        ]
    },
    {
        title: "Language",
        sub: [
            {
                title: "Add Languages",
                routing: "add-languages"
            },
            {
                title: "View Languages",
                routing: "view-languages"
            },
            {
                title: "View Trash Languages",
                routing: "view-trash-languages"
            }
        ]
    },
    {
        title: "Objective",
        sub: [
            {
                title: "Add Objectives",
                routing: "add-objectives"
            },
            {
                title: "View Objectives",
                routing: "view-objectives"
            },
            {
                title: "View Trash Objectives",
                routing: "view-trash-objectives"
            }
        ]
    },
    {
        title: "Quote",
        sub: [
            {
                title: "Add Quote",
                routing: "add-quote"
            },
            {
                title: "View Quote",
                routing: "view-quote"
            },
            {
                title: "View Trash Quote",
                routing: "view-trash-quote"
            }
        ]
    },
    {
        title: "Keywords",
        sub: [
            {
                title: "Add Keywords",
                routing: "add-keyword"
            },
            {
                title: "View Keywords",
                routing: "view-keywords"
            },
            {
                title: "View Trash Keywords",
                routing: "view-trash-keywords"
            }
        ]
    },
    {
        title: "Complaint",
        sub: [
            {
                title: "View Complaint Consultant",
                routing: "view-complaint-consultant"
            },
            {
                title: "View Complaint Client",
                routing: "view-complaint-client"
            }
        ]
    },
    {
        title: "Complaint Type",
        sub: [
            {
                title: "Add Complaint Type",
                routing: "add-complaintType"
            },
            {
                title: "View ComplaintType",
                routing: "view-complaintType"
            },
            {
                title: "View Trash ComplaintType",
                routing: "view-trash-complaintType"
            }
        ]
    },
    {
        title: "Digital Product",
        sub: [
            {
                title: "Add Digital Product",
                routing: "add-digital-product"
            },
            {
                title: "View Digital Product",
                routing: "view-digital-product"
            },
            {
                title: "View Trash Digital Product",
                routing: "view-trash-digital-product"
            }
        ]
    },
    {
        title: "User Waiting List",
        sub: [
            {
                title: "View User Waiting List",
                routing: "view-user-waiting-list"
            },
            {
                title: "View Contact Us List",
                routing: "view-contact-us-list"
            },
            {
                title: "View User Starter Kit Requests",
                routing: "view-user-starter-kit-requests"
            }
        ]
    }
]

export default data;